<template>
    <div v-on:click="handleCopy">
        <slot />
    </div>
</template>
<script>
    export default {
        name: 'dm-coupon-button',
        props: {
            code: {
                type: String,
                required: true
            }
        },
        data: function () {
            return {
                copied: false,
                timeout: 10000
            };
        },
        methods: {
            createElement: function () {
                var elem = document.createElement('textarea');
                Object.assign(elem.style, {
                    position: 'fixed',
                    bottom: 0,
                    right: 0,
                    width: '1px',
                    height: '1px',
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none',
                    background: 'transparent'
                });
                elem.value = this.code;
                return elem;
            },
            handleCopy() {
                var elem = this.createElement();
                document.body.appendChild(elem);
                elem.focus();
                elem.select();
                try {
                    var successful = document.execCommand('copy');

                    if (successful) {
                        this.copied = true;
                        this.returnToDefault();
                    }
                } catch (e) {
                    this.$emit('error', e);
                }

                this.$emit('copy');
                document.body.removeChild(elem);
            },
            returnToDefault: function () {
                return setTimeout(function () {
                    this.copied = false;
                }.bind(this), this.timeout);
            }
        }
    };
</script>
